import { keyframes } from 'styled-components'
import { theme } from '../theme'

export const shimmerAnim = keyframes`
  0% {
    background-color: ${theme.color.gray[100]};
  }
  50% {
    background-color: ${theme.color.gray[200]};
  }
  100% {
    background-color: ${theme.color.gray[100]};
  }
`
